<template>
  <div class="page">
    <div class="bj-img-div">
      <van-nav-bar
        title="登录密码重置"
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      />
      <div class="form-div">
        <div class="form-top-div">
          <div class="label-div">联系电话</div>
          <van-field v-model="telephone" placeholder="请输入您的手机号" maxlength="11"/>
          <div class="label-div password-div">验证码</div>
          <van-field
            v-model="sms"
            center
            clearable
            placeholder="请输入短信验证码"
            maxlength="6"
          >
            <template #button>
              <van-button class="verification-code-button" @click="getCode" :disabled="isSmsSend">{{sendBtnText}}</van-button>
            </template>
          </van-field>
          <div class="label-div password-div">新密码</div>
          <van-field v-model="password" type="password" placeholder="8-20位英文和数字" maxlength="20"/>
          <div class="label-div password-div">再次输入新密码</div>
          <van-field v-model="passwordCfm" type="password" placeholder="再次输入密码" maxlength="20"/>
        </div>
        <div class="button-div">
          <van-button color="#CE0022" class="login-button button-shadow" @click="submit">提交</van-button>
        </div>
        <div class="tip-div">
          提示：密码必须同时包含字母和数字
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerificationCode, resetPwd } from '../api/login'
export default {
  name: 'Reset',
  data () {
    return {
      telephone: '', // 手机号
      password: '', // 新密码
      sms: '', // 验证码
      passwordCfm: '', // 确认密码
      isSmsSend: false, // 是否已经发送了验证码
      timer: null,
      sendBtnText: '获取', // 获取验证码按钮文本
      counter: 60 // 倒计时秒数
    }
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },
    getCode () {
      if (this.telephone === '') {
        this.$toast.fail('请输入手机号')
        return
      }
      const tall = encodeURI(this.telephone)
      const params = {
        mobile: tall,
        type: 'reset'
      }
      getVerificationCode(params).then(res => {
        if (res.data.success) {
          this.$toast.success('已发送')
        } else {
          this.$toast.fail(res.data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
      // 将按钮禁用，防止再次点击
      this.isSmsSend = true
      // 开始倒计时，60s之后才能再次点击
      this.countDown()
    },
    submit () {
      if (this.sms === '') {
        this.$toast.fail('请输入验证码')
        return
      }
      if (this.password === '' || this.passwordCfm === '') {
        this.$toast.fail('请输入密码')
        return
      }
      if (this.password !== this.passwordCfm) {
        this.$toast.fail('两次密码不一致，请重新输入')
        this.passwordCfm = ''
        this.password = ''
        return
      }
      const params = {
        mobile: this.telephone,
        code: this.sms,
        password: this.password
      }
      resetPwd(params).then(res => {
        if (res.data.success) {
          this.$toast.success('重置密码成功')
          // 返回登录页面
          // this.$router.push({ path: '/' })
        } else {
          this.$toast.fail(res.data.message)
        }
      }).catch((err) => {
      })
    },

    // 倒计时
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `${this.counter}s`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          this.reset()
        }
      }, 1000)
    },

    // 重置倒计时
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '获取'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
  .bj-img-div {
    background-image: url("../assets/bj.png");
    background-size: 100%;
    background-repeat: no-repeat;
    height: 100%;
  }

  .van-nav-bar {
    background-color: transparent;
  }

  .page {
    width: 100%;
    background: #F7F8FA;
    height: 100%;
  }

  .form-div {
    width: 92%;
    background: #FFFFFF;
    border-radius: 8px;
    margin-left: 4%;
    height: 70%;
    position: absolute;
    bottom: 30px;
    overflow: auto;
  }

  .form-top-div {
    padding: 7% 5% 7% 5%;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
  }

  /deep/ .van-field__control {
    font-size: 18px;
  }

  .van-cell {
    padding-left: 0;
    padding-right: 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  .password-div {
    margin-top: 15px;
  }

  .login-button {
    width: 95%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 95%;
    margin-left: 5%;
    margin-bottom: 10px;
  }

  .verification-code-button {
    width: 62px;
    height: 27px;
    border: 1px solid #C7001F;
    border-radius: 4px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #CE0022;
  }

  .tip-div {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    padding-left: 5%;
  }
</style>
